import ApplicanForm from '../ApplicantForm/ApplicantForm';
import { CreditApplicationType } from '../../../../utils/enums/financialTypes.enum';
import FormSectionPage from '../../ui/formSectionPage';
import { useLocalization } from '../../../../utils/useLocalization';
import { state as initialState, JointAppContext } from './context';
import React, { useEffect, useState } from 'react';
import './style.scss';

export interface IApplicantInfo {
    applicationType: string;
    applicantData: any;
    setApplicantData: Function;
    coapplicantData: any;
    setCoapplicantData: Function;
    applicantValid: boolean;
    setApplicantValid: Function;
    isOpen: boolean;
    setOpen: Function;
    isBlocked?: boolean;
    initialPrimaryApplicant?: any;
    initialJointOrCoApplicant?: any;
    initialJointOrCoAppRelationship?: any;
    isEditMode?: boolean;
    disablePrintAndSubmitBtn: Function;
}

const CERO = 0;

const ApplicantInfo: React.FC<IApplicantInfo> = ({
    applicationType,
    applicantData,
    setApplicantData,
    coapplicantData,
    setCoapplicantData,
    applicantValid,
    setApplicantValid,
    isOpen,
    setOpen,
    isBlocked = false,
    initialPrimaryApplicant = null,
    initialJointOrCoApplicant = null,
    initialJointOrCoAppRelationship = null,
    isEditMode = false,
    disablePrintAndSubmitBtn,
}) => {
    const { applicantInfo, occupationIndividualInformation } =
        useLocalization();
    const [disabledForm, setDisabledForm] = useState<boolean>(false);
    const [showicon, setShowIcon] = useState<boolean | null>(null);
    const [applicantSubmit, setApplicantSubmit] = useState<any>(null);
    const [coApplicantSubmit, setCoApplicantSubmit] = useState<any>(null);
    const [isPrimaryAppFieldValueUpdated, setIsPrimaryAppFieldValueUpdated] =
        useState<boolean>(false);
    const [isCoAppFieldValueUpdated, setIsCoAppFieldValueUpdated] =
        useState<boolean>(false);

    const isJointOrCoApp =
        applicationType.includes(CreditApplicationType.JOINT) ||
        applicationType.includes(CreditApplicationType.COAPP);

    const changeApplicant = (handler: any) => {
        setApplicantSubmit(handler);
    };

    const changeCoApplicant = (handler: any) => {
        setCoApplicantSubmit(handler);
    };

    function handleSubmit() {
        if (applicantSubmit) {
            applicantSubmit.validate();
        }
        if (
            applicationType.includes(CreditApplicationType.JOINT) ||
            applicationType.includes(CreditApplicationType.COAPP)
        ) {
            if (coApplicantSubmit) {
                coApplicantSubmit.validate();
            }
        }
    }

    useEffect(() => {
        const isIndividualNoUpdate =
            isEditMode && !isJointOrCoApp && !isPrimaryAppFieldValueUpdated;
        const isJointOrCoNoUpdate =
            isEditMode &&
            isJointOrCoApp &&
            !isPrimaryAppFieldValueUpdated &&
            !isCoAppFieldValueUpdated;
        if (isIndividualNoUpdate || isJointOrCoNoUpdate) {
            return;
        }
        let isSectionValid = false;
        if (applicantSubmit) {
            if (Object.keys(applicantData).length > CERO) {
                isSectionValid = true;
            }
            if (
                (applicationType.includes(CreditApplicationType.JOINT) ||
                    applicationType.includes(CreditApplicationType.COAPP)) &&
                coApplicantSubmit
            ) {
                if (
                    Object.keys(applicantData).length > CERO &&
                    Object.keys(coapplicantData).length > CERO
                ) {
                    isSectionValid = true;
                } else {
                    isSectionValid = false;
                }
            }

            if (isSectionValid) {
                if (!isEditMode || (isEditMode && isOpen)) {
                    setShowIcon(true);
                    setOpen(false);
                    setDisabledForm(true);
                    setApplicantValid(true);
                }
            } else {
                setShowIcon(false);
                setOpen(true);
                setDisabledForm(false);
                setApplicantValid(false);
            }
        }
    }, [applicantData, coapplicantData]);

    useEffect(() => {
        if (showicon === true) setOpen(false);
        else if (showicon === false) {
            setOpen(true);
            setShowIcon(false);
        }
    }, [showicon]);

    useEffect(() => {
        if (!applicantValid) {
            setDisabledForm(false);
        }
    }, [applicantValid]);

    const onEdit = () => {
        setApplicantValid(false);
        setDisabledForm(false);
        if (isEditMode) {
            disablePrintAndSubmitBtn(true);
        }
    };
    return (
        <FormSectionPage
            title={applicantInfo.TITLE}
            handlerSubmit={handleSubmit}
            isOpen={isOpen}
            setOpen={setOpen}
            showIcon={showicon}
            isDisabled={disabledForm}
            onEdit={onEdit}
            isEditMode={isEditMode}
            isBlocked={isBlocked}
            disablePrintAndSubmitBtn={disablePrintAndSubmitBtn}
        >
            <fieldset disabled={disabledForm} className={'applicant-info'}>
                <JointAppContext.Provider value={initialState}>
                    {(applicationType.includes(CreditApplicationType.JOINT) ||
                        applicationType.includes(
                            CreditApplicationType.COAPP,
                        )) && (
                        <div className='o-fieldset__row mb-0'>
                            <div className='o-layout'>
                                <div className='o-layout__item  u-1/1  u-1/1@xs'>
                                    <h6 className='section-title'>
                                        {
                                            occupationIndividualInformation.PRIMARY_APP
                                        }
                                    </h6>
                                </div>
                            </div>
                        </div>
                    )}

                    <ApplicanForm
                        key={'Applicant'}
                        applicationType={applicationType}
                        handlerUpdate={changeApplicant}
                        isDisabled={disabledForm}
                        setApplicantData={setApplicantData}
                        setCoapplicantData={setCoapplicantData}
                        initialPrimaryApplicant={initialPrimaryApplicant}
                        isEditMode={isEditMode}
                        isFieldValueUpdated={isPrimaryAppFieldValueUpdated}
                        setIsFieldValueUpdated={
                            setIsPrimaryAppFieldValueUpdated
                        }
                    />
                    {applicationType.includes(CreditApplicationType.JOINT) ||
                    applicationType.includes(CreditApplicationType.COAPP) ? (
                        <>
                            <br />
                            <hr></hr>
                            <br />
                            <div className='o-fieldset__row mb-0'>
                                <div className='o-layout'>
                                    <div className='o-layout__item  u-1/1  u-1/1@xs'>
                                        <h6 className='section-title'>
                                            {applicationType ==
                                            CreditApplicationType.COAPP
                                                ? occupationIndividualInformation.CO_APP
                                                : occupationIndividualInformation.JOINT_APP}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                            <ApplicanForm
                                key={'Coapplicant'}
                                applicationType={applicationType}
                                handlerUpdate={changeCoApplicant}
                                isDisabled={disabledForm}
                                setApplicantData={setApplicantData}
                                setCoapplicantData={setCoapplicantData}
                                isCoApplicant={true}
                                initialPrimaryApplicant={
                                    initialJointOrCoApplicant
                                }
                                initialJointOrCoAppRelationship={
                                    initialJointOrCoAppRelationship ?? null
                                }
                                isEditMode={isEditMode}
                                isFieldValueUpdated={isCoAppFieldValueUpdated}
                                setIsFieldValueUpdated={
                                    setIsCoAppFieldValueUpdated
                                }
                            />
                        </>
                    ) : null}
                </JointAppContext.Provider>
            </fieldset>
        </FormSectionPage>
    );
};

export default ApplicantInfo;
